import { render, staticRenderFns } from "./termos-de-uso.vue?vue&type=template&id=3dea7a04&scoped=true"
import script from "./termos-de-uso.vue?vue&type=script&lang=ts"
export * from "./termos-de-uso.vue?vue&type=script&lang=ts"
import style0 from "./termos-de-uso.vue?vue&type=style&index=0&id=3dea7a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dea7a04",
  null
  
)

export default component.exports